import request from "./request.js";

export default {
  // 登录
  login: (data) => {
    return request({
      url: "api/admin/login",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
};
